__turbopack_context__.v({
  "dark": "theme-module-scss-module__PtEkjG__dark",
  "light": "theme-module-scss-module__PtEkjG__light",
});
